/* eslint-disable */
import store from '@/store/index';
import cookie from 'js-cookie';

let cachedInstance = null;
class VolacnoBasePoint {
    getUserInfo(store) {
        const {userCode, mainPostName, userName,userType} = store.state.user;
        let orgName = store.state.user.orgName || null;
        if(userType !=1 && orgName == null){
            orgName = '外部用户';
        }
        return {userCode,orgName, mainPostName, userName}
    }
    getModuleNameByTenantCode(store) {
        const tenantCodeParams = {
            'T20191228000061': '国家二级节点',
            '88.182.100': 'Midea内销',
            '88.182.101': 'Midea外销'
        };
        const { tenantCode } = store.state.currentTenant;
        return tenantCodeParams[tenantCode];
    }
    initUserCode() {
        const cookieUser = cookie.get('apmUser');
        const {userCode,orgName, mainPostName,userName} = this.getUserInfo(store);
        window.collectEvent('config', {
            user_unique_id: userCode || cookieUser
        });
        window.collectEvent('profileSet', {
            systemCode: this.getModuleNameByTenantCode(store) ,
            orgName,
            mainPostName,
            userName
        })
    }
    setRequest(requestObject) {
        const refer_event_index = localStorage.getItem('refer_event_index');
        const { event_name, ...requestParams } = requestObject;
        const currentTenantName = this.getModuleNameByTenantCode(store);
        const baseParams = { ...requestParams, currentTenantName, refer_event_index };
        window.collectEvent(event_name, baseParams);
        localStorage.setItem('refer_event_index', baseParams.event_index);
    }
    /**
     * @description 行为事件点击
     * @param {*} currentBehavior
     */
    behaviorBasePoint(currentBehavior) {
        this.initUserCode();
        this.setRequest(currentBehavior);
    }
};

const getVolcengine = ()=>{
    if(cachedInstance === null ) {
        cachedInstance =  new VolacnoBasePoint();
    }
    return cachedInstance;
};

export default getVolcengine();
